import { render } from "./fish.vue?vue&type=template&id=16740bf6&scoped=true"
import script from "./fish.vue?vue&type=script&lang=js"
export * from "./fish.vue?vue&type=script&lang=js"

import "./fish.vue?vue&type=style&index=0&id=16740bf6&lang=scss&scoped=true"
import "./fish.vue?vue&type=style&index=1&id=16740bf6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16740bf6"]])

export default __exports__